import React from 'react';
import PropTypes from 'prop-types';

import EntityField from '../internal/EntityField';

export default function CustomField({
  name,
  label,
  viewComponent: ViewComponent,
  editComponent: EditComponent,
  loading,
  disabled,
  required,
  editable,
  columns,
  ...rest
}) {
  return (
    <EntityField
      columns={columns}
      disabled={disabled}
      editable={editable}
      name={name}
      required={required}
    >
      {(editing, field, { disabled }) =>
        editing && editable ? (
          <EditComponent
            disabled={disabled}
            label={label}
            loading={loading}
            {...field}
            {...rest}
          />
        ) : (
          <ViewComponent
            label={label}
            loading={loading}
            value={field.input.value}
            {...rest}
          />
        )
      }
    </EntityField>
  );
}
CustomField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  editable: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  viewComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  editComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  columns: PropTypes.number,
};
CustomField.defaultProps = {
  editable: true,
  loading: false,
  required: false,
  disabled: false,
  columns: null,
};
